import { Turnstile } from "@marsidev/react-turnstile";
import { forwardRef, useEffect } from "react";

const CAPTCHA_ENABLED = process.env.REACT_APP_ENABLE_CAPTCHA !== "false";
const CAPTCHA_BYPASS_CODE = process.env.REACT_APP_CAPTCHA_CODE_BYPASS;

// eslint-disable-next-line react/display-name
const CaptchaWidget = forwardRef(({ onSuccess, options, ...props }, ref) => {
  useEffect(() => {
    if (!CAPTCHA_ENABLED && onSuccess) {
      onSuccess(CAPTCHA_BYPASS_CODE);
    }
  }, []);

  if (!CAPTCHA_ENABLED) return null;

  return (
    <Turnstile
      ref={ref}
      siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
      onSuccess={onSuccess}
      options={options || { theme: "light", size: "normal" }}
      {...props}
    />
  );
});

export default CaptchaWidget;
